import jsonLdHelper from './jsonLdHelper'

const jsonLdFrontendonly = (product, currentIso) => ({
    ...jsonLdHelper,
    completeJson: '',
    init() {
        this.completeJson = {
            '@context': 'https://schema.org/',
            '@type': 'Product',
            sku: product.reference,
            name: product[currentIso].title,
            image: product.image,
            mpn: product.reference,
            url: window.location.origin + product[currentIso].uri,
            description: product[currentIso].meta_description,
        }

        if (Object.prototype.hasOwnProperty.call(product, 'stock_and_pricing')) {
            this.applyOfferFromPriceAndStock(product.stock_and_pricing)
            this.applyBrandFromPriceAndStock(product.stock_and_pricing)
            this.applyRatingFromPriceAndStock(product.stock_and_pricing)
            if (Object.prototype.hasOwnProperty.call(product.stock_and_pricing, 'ean13')) {
                this.completeJson.gtin = product.stock_and_pricing.ean13
            }
        }

        this.buildMarkup()
    },
})
document.addEventListener('alpine:init', () => {
    window.Alpine.data('jsonLdFrontendonly', jsonLdFrontendonly)
})
